module.exports = __webpack_public_path__ + "img/ko.3e5fd285.png";